export const ACADEMIC = 'ACADEMIC';
export const LANGUAGES = 'LANGUAGES';
export const HOBBIES = 'HOBBIES';
export const TRIAL = 'TRIAL';
export const REFERENCES = 'REFERENCES';
